import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../../base.service";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../environments/environment";

// declare var API_HOST: string;

@Injectable()
export class AllProductsService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("list-all-products");
  }

  getAllProducts(filters) {
    let headers = new Headers();
    headers.append("Accept", "application/json");
    let item = {
      season: filters.season,
      filter: filters.filter,
      authId: filters.authId
    };

    if (filters.required_token) {
      item["required_token"] = true;
    }

    return this.http
      .post(this.baseURL(), JSON.stringify(item), { headers: headers })
      .toPromise()
      .then(response => {
        let res = response.json();
        if (res["token"]) {
          this.setCookie("token", res["token"]);
        }
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/products/all-products/all_products.service.ts